module.exports = __webpack_public_path__ + "img/method-draw-image.c2e38818.svg";